import { useHistory } from 'react-router-dom';
import { EcosystemListingStub } from 'trellis-ecosystem';
import { buildListingUrl, navigateToSearchResults } from '../utils/navigation';
import { AutocompleteItem } from './AutocompleteItem';
import { SearchGroupItem } from './SearchGroupItem';
import { jsx as _jsx } from "react/jsx-runtime";
export function SearchOption({
  item,
  searchTerm
}) {
  const history = useHistory();
  switch (item.resultType) {
    case 'QUERY':
      return /*#__PURE__*/_jsx(AutocompleteItem, {
        keyword: searchTerm,
        queryType: item.queryType,
        suggestion: item.term,
        onClick: () => navigateToSearchResults(item, history)
      });
    case 'LISTING':
      return /*#__PURE__*/_jsx(EcosystemListingStub, {
        imageSrc: item.iconUrl || '',
        listingHref: buildListingUrl(item.slug),
        name: item.term || '',
        productType: item.productType || 'APP',
        providerName: item.providerName || ''
      });
    case 'CATEGORY':
      return /*#__PURE__*/_jsx(SearchGroupItem, {
        item: item,
        keyword: searchTerm,
        onClick: () => navigateToSearchResults(item, history)
      });
    case 'COLLECTION':
      return /*#__PURE__*/_jsx(SearchGroupItem, {
        item: item,
        keyword: searchTerm,
        onClick: () => navigateToSearchResults(item, history)
      });
    default:
      return null;
  }
}